@if (showSplash) {
  <div class="app-splash-screen" [ngStyle]="{ left: windowWidth, opacity: opacityChange, transition: splashTransition }"
    >
    <div class="app-splash-inner">
      <!-- Label and dots hang below the logo, which stays centred alone: the
           native launch screens draw the logo there and nothing else. -->
      <div id="app-logo" class="app-logo">
        <div class="app-splash-below">
          @if (!this.subscribedThemeTitle) {
            <div class="app-label">Urbanhub</div>
          }
          <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
